import { CheckCircle2, Zap, Shield, Building2 } from 'lucide-react';

const icons = {
  Zap: Zap,
  Shield: Shield,
  CheckCircle2: CheckCircle2,
  Building2: Building2,
};

export default function IconBox({ icon, title, description }) {
  const Icon = icons[icon] || CheckCircle2;
  
  return (
    <div className="flex flex-col items-center text-center p-4 min-[992px]:p-[30px] bg-slate-900 text-white">
      <div className="bg-slate-800 p-3 mb-6">
        <Icon className="w-8 h-8 text-white" />
      </div>
      <h3 className="text-xl font-bold uppercase tracking-tight mb-4">{title}</h3>
      <p className="text-slate-400 text-sm leading-relaxed">
        {description}
      </p>
    </div>
  );
}
